// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"db9382ce","64":"d01e8ac6","159":"0b7bd0b4","196":"c95e548c","453":"63f13ad2","617":"929808c5","667":"057c1a7f","715":"0ae7cf7b","733":"35a24dc5","764":"441dc464","853":"0126c48a"}[chunkId] + ".chunk.js";
};